<div class="st-mini-kanban">
  <div class="st-mini-kanban-column" *ngFor="let column of columns">

    <!-- Column header -->
    <div class="st-mini-kanban-header">
      <div class="d-flex justify-content-between align-items-center gap-2">
        <span class="st-mini-kanban-dot" [style.background]="column.color"></span>
        <span class="st-mini-kanban-label">{{ column.label }}</span>
      </div>
      <span class="d-flex align-items-center">
        <span class="st-mini-kanban-count">{{ column.subtasks.length }}</span>
        <button class="sp-col-add-btn" type="button" matTooltip="Add Child Case"
          (click)="onCreateSubtaskInColumn(column.id, $event)">
          <mat-icon>add</mat-icon>
        </button>
      </span>
    </div>

    <!-- Droppable area -->
    <div class="st-mini-kanban-body" cdkDropList [id]="column.id" [cdkDropListData]="column.subtasks"
      [cdkDropListConnectedTo]="connectedLists" (cdkDropListDropped)="onSubtaskDrop($event)">

      <div *ngFor="let st of column.subtasks" cdkDrag [cdkDragData]="st">
        <app-subtask-compact-card
          [subtask]="st"
          [taskTypeOptions]="taskTypeOptions"
          (cardClicked)="onSubtaskCardClick($event)"
          (commentsClicked)="onSubtaskCommentsClick($event)"
          (attachmentsClicked)="onSubtaskAttachmentsClick($event)">
        </app-subtask-compact-card>
        <!-- Custom empty placeholder so CDK doesn't clone the card into the source slot. -->
        <div *cdkDragPlaceholder class="st-drag-placeholder"></div>
      </div>
    </div>
  </div>
</div>